import Cookies from "universal-cookie";

const cookies = new Cookies();

const ObtieneDatosCookies = () => {
  // Primero intentamos recuperar la sesión nueva.
  let usuario = null;

  try {
    const guardado = localStorage.getItem("usuarioSIGEDI");
    usuario = guardado ? JSON.parse(guardado) : null;
  } catch (error) {
    console.error("Error leyendo sesión SIGEDI:", error);
  }

  // Compatibilidad con las cookies anteriores.
  const obtener = (campo, cookie = campo) => {
    return usuario?.[campo] ?? cookies.get(cookie, { path: "/" });
  };

  return {
    id: obtener("id"),
    nombre: obtener("nombre", "nombreUsuario"),
    apellido: obtener("apellido", "apellidoUsuario"),
    identificacion: obtener("identificacion"),
    sedeID: obtener("sedeID"),
    destino: obtener("destino"),
    nivel: obtener("nivel"),
    estado: obtener("estado"),
    blanqueoContrasena: obtener("blanqueoContrasena"),
    dependenciaNombre: obtener("dependenciaNombre"),
    funcion: obtener("funcion"),
    createdAt: obtener("createdAt"),
    updatedAt: obtener("updatedAt"),

    // Compatibilidad temporal; no guardar contraseñas en cookies.
    pass: undefined,

    tokenJWT: localStorage.getItem("tokenJWT"),
  };
};

export default ObtieneDatosCookies;